import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Components/Home';
import Dashboard from './Components/Dashboard';
import Consultations from './Components/Consultations';
import Doctors from './Components/Doctors';
import Patients from './Components/Patients';
import Dash1 from './Components/Dash1';
import Dash2 from './Components/Dash2';
import FollowUp from './Components/FollowUp';
import GoalSettings from './Components/GoalSettings';
import DetailedAssessment from './Components/DetailedAssessment';
import HealthPlans from './Components/HealthPlans';
import SuperAdminLogin from './Components/SuperAdminLogin';
import SuperAdminReg from './Components/SuperAdminReg';
import DocProf from './Components/DocProf';
import ProtectedRoute from './Components/ProtectedRoutes';
import { useState } from 'react';
import MyProf from './Components/MyProf';

function App() {

  const [authError , setAuthError] = useState(null);

  return (
    <Router>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route path='/' element={<Home />}>
            <Route path='/' element={<Dashboard />}>
              <Route path='/' element={<Dash1 />} />
              <Route path='/docprof' element={<DocProf />} />
              <Route path='/myprof' element={<MyProf />} />
              <Route path='/doctor/:id' element={<DocProf />} />
              <Route path='/dash2/:id' element={<Dash2 />}>
                <Route path='/dash2/:id' element={<GoalSettings />} />
                <Route path='/dash2/:id/detass' element={<DetailedAssessment />} />
                <Route path='/dash2/:id/folup' element={<FollowUp />} />
                <Route path='/dash2/:id/helpan' element={<HealthPlans />} />
              </Route>
            </Route>


            <Route path='/consultations' element={<Consultations />} />
            <Route path='/doctors' element={<Doctors />} />
            <Route path='/patients' element={<Patients />} />

          </Route>
        </Route>
        <Route path='/login' element={<SuperAdminLogin  />} />
        <Route path='/register' element={<SuperAdminReg />} />
      </Routes>
    </Router>
  );
}

export default App;
